import { render } from "./AreaComercialDetalles.vue?vue&type=template&id=03fe6a52&scoped=true"
import script from "./AreaComercialDetalles.vue?vue&type=script&lang=js"
export * from "./AreaComercialDetalles.vue?vue&type=script&lang=js"

import "./AreaComercialDetalles.vue?vue&type=style&index=0&id=03fe6a52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fe6a52"]])

export default __exports__